module.exports = __webpack_public_path__ + "static/media/jenkins.62c38a30.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/jenkins.png
// module id = 125
// module chunks = 0